import {
  IStoreListApiResponse,
  IStoreSingleApiResponse,
  StoreAPIService,
} from "src/api/Stores/API_StoreService";
import { IGenericImport } from "src/models/General/registerGroup.models";
import { IStore, IPriceGroupDetail } from "src/models/Stores/Store.models";
import { PaginationParams } from "src/shared/models/PaginationParams.models";
import {
  setStoreList,
  setStoreToEdit,
  addStore,
  updateStore,
  deleteStore,
  concatListStore,
  addStores,
} from "src/store/Stores/slices/storeSlice";

const MapIPriceGroupDetailFromList = (
  store: IStore,
  priceGroupId: number,
  priceGroupXStoreId?: number
) => {
  return {
    priceGroupXStoreId: priceGroupXStoreId ?? 0,
    priceGroupId: priceGroupId,
    storeId: store?.storeId ?? 0,
    status: true,
  } as IPriceGroupDetail;
};

const getStoreById = (dispatch, id: number) => {
  return new Promise<IStoreSingleApiResponse>(async (resolve, reject) => {
    try {
      const response = await StoreAPIService.getById(id);
      if (response?.success) {
        dispatch(setStoreToEdit(response?.data));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const getAllStores = (dispatch: any, pagination?: PaginationParams) => {
  return new Promise<IStoreListApiResponse>(async (resolve, reject) => {
    try {
      const response = await StoreAPIService.getAll(pagination?.params);
      if (response?.success) {
        if (pagination?.concat) dispatch(concatListStore(response?.data));
        else dispatch(setStoreList(response?.data));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const AddNewStore = (dispatch, newItem: IStore) => {
  return new Promise<IStoreSingleApiResponse>(async (resolve, reject) => {
    try {
      const response = await StoreAPIService.create(newItem);
      if (response.success) {
        dispatch(addStore(response?.data));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const MassiveAddStore = (dispatch: any, newItem: IGenericImport[]) => {
  return new Promise<IStoreListApiResponse>(async (resolve, reject) => {
    try {
      const response = await StoreAPIService.massiveCreate(newItem);
      if (response.success) {
        dispatch(addStores(response?.data ?? []));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const updateStoreOnList = (dispatch, newItem: IStore) => {
  return new Promise<IStoreSingleApiResponse>(async (resolve, reject) => {
    try {
      const response = await StoreAPIService.update(newItem);
      if (response.success) {
        dispatch(updateStore(response?.data));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const RestoreStore = (dispatch, Id: number) => {
  return new Promise<IStoreSingleApiResponse>(async (resolve, reject) => {
    try {
      const response = await StoreAPIService.restore(Id);
      if (response.success) {
        dispatch(deleteStore(response?.data?.storeId));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
}

const DeleteStore = (dispatch, newItem: IStore) => {
  return new Promise<IStoreSingleApiResponse>(async (resolve, reject) => {
    try {
      const toUpdated = { ...newItem };
      toUpdated.status = false;
      const response = await StoreAPIService.update(toUpdated);
      if (response.success) {
        dispatch(deleteStore(response?.data?.storeId));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

export {
  MapIPriceGroupDetailFromList,
  getAllStores,
  getStoreById,
  AddNewStore,
  MassiveAddStore,
  updateStoreOnList,
  RestoreStore,
  DeleteStore,
};
